var nb = require('../../../nb');
var ProductItem = nb.define({
    view: {
        tag: 'li',
        'class': 'swiper-slide',
        $html: {
            tag: 'a',
            'class': 'product-item ',
            href: nb.bind('detailHref'),
            target: '_blank',
            $html: [{
                'class': 'product-img',
                $html: [{
                    'class': 'img-item front lazyload',
                    tag: 'img',
                    'data-original': nb.bind('imgUrl'),
                    alt: nb.bind('name')
                    // }, {
                    //     'class': 'img-item reverse',
                    //     tag: 'img',
                    //     src: nb.bind('reverseImg'),
                    //     alt: nb.bind('name')
                }]
            }, {
                'class': 'item-info',
                $html: [{
                    'class': 'info-title',
                    $text: nb.bind('name')
                }, {
                    'class': 'info-title-en',
                    $text: nb.bind('engName')
                }, {
                    'class': 'info-price',
                    $text: nb.bind('price')
                }]
            }]
        }
    }
});
var ProductList = nb.define({
    // parent:nb.view.List,
    view: {
        'class': 'product-list',
        $html: {
            'class': 'swiper-container',
            id: nb.bind('swiperId'),
            $html: [{
                'class': "swiper-wrapper",
                $type: nb.view.List,
                $model: ''
            },{
                'class': 'swiper-button-prev swiper-button-black'
            }, {
                'class': 'swiper-button-next swiper-button-black'
            }]
        }
    },
    method: {
        onModelReady: function (inModel) {
            nb.model.onChange(nb.opts.clientReady,function () {
                inModel.onChange('items', function () {
                    var swiperId = inModel.get('swiperId');
                    new Swiper('#' + swiperId, {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        prevButton:'.swiper-button-prev',
                        nextButton:'.swiper-button-next',
                        breakpoints: {
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            }
                        }
                    });
                }, this);
            },this);

        }
    }
});
var SeriesItem = nb.define({
    view: {
        'class': 'series-item',
        $html: [{
            'class': 'bg-img',
            $html: {
                tag: 'img',
                'class':'lazyload',
                'data-original': nb.bind('image'),
                alt: nb.bind('name')
            }
        }, {
            'class': 'series-info',
            $html: [{
                'class': 'title',
                $html: [{
                    'class': 'title-en',
                    $text: nb.bind('engName')
                }, {
                    'class': 'title-cn',
                    $text: nb.bind('name')
                }]
            }, {
                'class': 'desc',
                $text: nb.bind('content')
            }, {
                'class': 'product-list-wrapper',
                $html: [{
                    $type: ProductList,
                    $model: 'productList'
                }]
            }, {
                tag: 'a',
                'class': 'show-all',
                href: nb.bind('seriesHref'),
                $html: {
                    tag:'img',
                    src:'image/icon/left-more.png'
                }
            }]
        }]
    }
});
var SeriesList = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'series-list'
    }
});

var seriesListWrapper = nb.define({
    view: {
        'class': 'series-list-wrapper',
        $html: [{
            'class': 'title',
            $html: {
                tag: 'span',
                $text: '生活方式'
            }
        }, {
            $type: SeriesList,
            $model: 'list'
        }]
    }
});

module.exports = {
    SeriesItem: SeriesItem,
    seriesListWrapper: seriesListWrapper,
    ProductList:ProductList,
    SeriesList:SeriesList,
    ProductItem: ProductItem
};


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/SeriesList.js
// module id = 81
// module chunks = 0 1 4